/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Video_FailedInputs */

const en_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error selecting video file`)
};

const fr_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la sélection du fichier vidéo`)
};

const de_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Auswählen der Videodatei`)
};

const it_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la selezione del file video`)
};

const ru_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при выборе видеофайла.`)
};

const es_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al seleccionar el archivo de vídeo`)
};

const zh_cn2_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择视频文件时出错`)
};

const ja_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイルの選択中にエラーが発生しました`)
};

const hi_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फ़ाइल चुनने में त्रुटि`)
};

const pt_pt2_audio_description_export_select_video_failed = /** @type {(inputs: Audio_Description_Export_Select_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao selecionar o arquivo de vídeo`)
};

/**
* | output |
* | --- |
* | "Error selecting video file" |
*
* @param {Audio_Description_Export_Select_Video_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_video_failed = /** @type {((inputs?: Audio_Description_Export_Select_Video_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Video_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_select_video_failed(inputs)
	if (locale === "de") return de_audio_description_export_select_video_failed(inputs)
	if (locale === "it") return it_audio_description_export_select_video_failed(inputs)
	if (locale === "ru") return ru_audio_description_export_select_video_failed(inputs)
	if (locale === "es") return es_audio_description_export_select_video_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_select_video_failed(inputs)
	if (locale === "ja") return ja_audio_description_export_select_video_failed(inputs)
	if (locale === "hi") return hi_audio_description_export_select_video_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_select_video_failed(inputs)
	return en_audio_description_export_select_video_failed(inputs)
});